import { Form, Select } from '@approvalmax/ui/src/components';
import { memo, useMemo } from 'react';

import { localClearingSystemKey } from '../../AddBeneficiaryPopupContent.constants';
import { FieldSelectProps } from './FieldSelect.types';

export const FieldSelect = memo<FieldSelectProps>((props) => {
    const { field, placeholder } = props;

    const items = useMemo(() => {
        return (
            field.field?.options?.map((option) => {
                const description = [
                    option.description || false,
                    option.payment_limit || false,
                    option.processing_time || false,
                ]
                    .filter(Boolean)
                    .join('\n');

                return {
                    id: option.value,
                    name: option.label,
                    description,
                    ...(field.path === localClearingSystemKey && { subName: description }),
                };
            }) || []
        );
    }, [field.field?.options, field.path]);

    return (
        <Form.Part>
            <Select
                label={field.field.label}
                name={field.path}
                placeholder={placeholder}
                hint={field.field.description}
                required={field.required}
                items={items}
                autocomplete
            />
        </Form.Part>
    );
});

FieldSelect.displayName = 'FieldSelect';
